export const shortenString = (str) => {
  if (str.length > 8) {
    return `${str.substring(0, 4)}...${str.substring(str.length - 4)}`;
  }

  return str;
};

export const formatDecimalNumber = (num) => {
  const number = (Number(num) / 1e6).toFixed(0).toLocaleString();
  return number.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
